const _excluded = ["state", "placement"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
import { Flipped, Flipper } from "react-flip-toolkit";
import { useToastRegion } from "@react-aria/toast";
import { cx } from "../../helpers/utils/cx";
import { Snackbar } from "./Snackbar";
const STAGGER_CONFIG = {
  default: {
    speed: 0.4
  }
};
export function SnackbarRegion(_ref) {
  let {
      state,
      placement = "bottom-left"
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const ref = React.useRef(null);
  const {
    regionProps
  } = useToastRegion(props, state, ref);
  return /*#__PURE__*/React.createElement(Flipper, {
    flipKey: state.visibleToasts.map(toast => toast.key),
    spring: "noWobble",
    staggerConfig: STAGGER_CONFIG
  }, /*#__PURE__*/React.createElement("div", _extends({}, regionProps, {
    ref: ref,
    className: cx("fixed z-50 flex flex-col gap-4", "bottom-4 left-4 right-4", "w-auto sm:w-[410px]", placement === "bottom-left" && "sm:right-auto", placement === "bottom-right" && "sm:left-auto", placement === "bottom-center" && "sm:left-0 sm:right-0 m-auto")
  }), state.visibleToasts.map(toast => {
    return /*#__PURE__*/React.createElement(Flipped, {
      key: toast.key,
      flipId: toast.key
    }, /*#__PURE__*/React.createElement("div", {
      className: cx("w-full will-change-transform")
    }, /*#__PURE__*/React.createElement(Snackbar, {
      key: toast.key,
      toast: toast,
      state: state
    })));
  })));
}